import Modal from "react-modal";
import React, { useState, useEffect } from "react";
import Styles from "./deomform.module.scss";
import { FaUserAlt, FaPhoneAlt } from "react-icons/fa";
import { FaBabyCarriage } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { useForm, SubmitHandler } from "react-hook-form";
import { Inputs, props } from "./types";
import { Services } from "../../../../Service/service";
import { Error } from "../../../../Reusable/utils/Toast";
import { TiWorld } from "react-icons/ti";

import { Country } from "country-state-city";
import { normalizePhoneCode } from "Reusable/utils/phoneUtils";
import { MdEmail } from "react-icons/md";
import { GiClassicalKnowledge } from "react-icons/gi";
import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";
import { getUTMData, triggerGenerateLead } from "../../../../Reusable/utils/utmTracker";

import useStore from "store";
Modal.setAppElement("#root");

const DemoForm: React.FC<props> = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);
    const {
        setThankYouModal,
        CourseId,
        SetDemoFormBeforeLogin,
        DemoFormBeforeLogin,
        SetCourseId,
    } = useStore((item: any) => item);
    let Countries = Country.getAllCountries();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        setError,
        watch,
        formState: { errors },
    } = useForm<Inputs>({ defaultValues: { CountryCode: "" }, mode: "onChange" });

    //Initial render
    useEffect(() => {
        if (!CourseId) {
            getCourses();
        }
    }, [CourseId]);
    // gtag('set', {'debug_mode': true});
    //FETCH COURSES
    async function getCourses() {
        try {
            const courseData = await Services.getCoursesByCategory(
                "POST",
                null,
                null
            );
            setCourses(courseData.Courses);
        } catch (err) {
            Error("something went wrong");
        }
    }
    // const
    // CLOSE FORM
    const closeModal = () => {
        SetDemoFormBeforeLogin(false);
        SetCourseId("");
        setValue("CountryCode", "");
        reset();
    };
    const watchCountryCode = watch("CountryCode");

    const validatePhoneNumber = (value: string) => {
        const country = Country.getAllCountries().find(
            (item) => item.isoCode === watchCountryCode
        );
        const isoCode = country?.isoCode?.toUpperCase() as CountryCode | undefined;
        const rawInput = String(value).trim();

        if (rawInput.startsWith("+")) {
            return "Do not include country code or '+' in this field";
        }
        if (rawInput.startsWith("0")) {
            return "Phone number cannot start with 0";
        }

        const inputDigits = rawInput.replace(/\D/g, "");
        const phoneNumber = parsePhoneNumberFromString(rawInput, isoCode ?? "IN");

        const len = inputDigits.length;
        if (len < 6 || len > 12) {
            return "Mobile number length seems invalid for this country";
        }

        if (!phoneNumber || !phoneNumber.isValid() || (phoneNumber.nationalNumber !== inputDigits)) {
            return "Invalid Phone Number";
        }
        return true;
    };

    // FORM SUBMIT
    const onSubmit: SubmitHandler<Inputs> = (data) => {
        const country = Country.getAllCountries().find(
            (item) => item.isoCode === data.CountryCode
        );

        const { LeadSource, LeadSourceCode, lead_url_string, utm_source, utm_medium } = getUTMData();
        setLoading(true);
        let body = JSON.stringify({
            ...data,
            CourseID: CourseId ? CourseId : data.CourseID,
            MobileNumber: `${data.MobileNumber}`,
            CountryCode: normalizePhoneCode(country?.phonecode || data.CountryCode),
            lead_source: LeadSourceCode || LeadSource,
            lead_url_string,
            utm_source,
            utm_medium,
        });

        Services.request_demo("POST", body, null)
            .then((response: any) => {
                console.log(response);
                if (response.Status === 1) {
                    triggerGenerateLead();
                    closeModal();
                    setThankYouModal(true);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                console.log(err);
                Error("something went wrong please try again");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            isOpen={DemoFormBeforeLogin}
            contentLabel="Modal"
            className={Styles["modal"]}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <header>
                    <h2>Request Demo </h2>
                    <p>
                        Fill this form to get in front of <span>Expert</span>
                    </p>
                </header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styles["form-control"]}>
                        <FaUserAlt className={Styles["icon"]} />
                        <input
                            {...register("ParentName", { required: true })}
                            placeholder="Your Name"
                        />
                        {errors.ParentName && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={`${Styles["form-control"]}`}>
                        <TiWorld className={Styles["icon"]} />
                        <select
                            defaultValue={""}
                            style={{ textIndent: "20px" }}
                            {...register("CountryCode", { required: true })}>
                            <option value="" disabled>
                                Select Country
                            </option>
                            {Country.getAllCountries().map((item) => {
                                const phone = normalizePhoneCode(item.phonecode);
                                return (
                                    <option value={item.isoCode} key={item.isoCode}>
                                        &#160; {item.name} {phone ? `(${phone})` : ""}
                                    </option>
                                );
                            })}
                        </select>
                        {errors.CountryCode && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={`${Styles["form-control"]}`}>
                        <FaPhoneAlt className={Styles["icon"]} />

                        <input
                            type="text"
                            maxLength={15}
                            {...register("MobileNumber", {
                                required: "This field is required",
                                validate: validatePhoneNumber,
                                onChange: (e) => {
                                    const target = e.target as HTMLInputElement;
                                    let sanitized = target.value.replace(/\D/g, "");
                                    while (sanitized.startsWith("0")) {
                                        sanitized = sanitized.substring(1);
                                    }
                                    target.value = sanitized;
                                }
                            })}
                            placeholder="Mobile Number without country Code"
                        />
                        {errors.MobileNumber && (
                            <span className={Styles["error"]}>
                                {errors.MobileNumber.message as string}
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <FaUserAlt className={Styles["icon"]} />
                        <input
                            {...register("StudentName", { required: true })}
                            placeholder="Child Name"
                        />
                        {errors.StudentName && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <FaBabyCarriage className={Styles["icon"]} />
                        <input
                            type="number"
                            step={0.01}
                            {...register("StudentAge", {
                                required: "This field is required",
                                validate: (value) => {
                                    const age = Number(value);
                                    if (age < 2 || age > 12) {
                                        return "Age must be between 2 and 12";
                                    }
                                    return true;
                                }
                            })}
                            placeholder="Child Age"
                        />
                        {errors.StudentAge && (
                            <span className={Styles["error"]}>
                                {errors?.StudentAge?.message}
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <MdEmail className={Styles["icon"]} />
                        <input
                            type="email"
                            {...register("EmailID", { required: true })}
                            placeholder="Email"
                        />
                        {errors.EmailID && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    {/* {!CourseId && (
                        <div className={Styles["form-control"]}>
                            <GiClassicalKnowledge className={Styles["icon"]} />
                            <select
                                style={{ textIndent: "20px" }}
                                {...register("CourseID", {
                                    required: true,
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    &#160; Select Course
                                </option>
                                {courses.map((item: any) => (
                                    <option value={item?.CourseID}>
                                        &#160; {item?.CourseName}
                                    </option>
                                ))}
                            </select>
                            {errors.CourseID && (
                                <span className={Styles["error"]}>
                                    This field is required
                                </span>
                            )}
                        </div>
                   )} */}

                    <div className={Styles["buttons"]}>
                        <button type="submit" className={Styles["submit"]} disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                        <button
                            type="button"
                            disabled={loading}
                            onClick={closeModal}
                            className={Styles["close"]}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
export default DemoForm;
